<!-- 组织信息 -->
<template>
  <div class="organization-info-view">
    <p class="info-title">园区运营机构信息&nbsp;&nbsp;{{ zcTeamList.length }}</p>

    <div class="borganization-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="zcTeamList"
          border
          style="width: 650px"
          header-cell-class-name="ly_table_light_header"
          cell-class-name="ly_table_light_cell"
        >
          <el-table-column
            prop="talentId"
            label="机构编号"
            align="center"
            width="260"
          ></el-table-column>

          <el-table-column
            prop="userName"
            label="机构全称"
            align="center"
            width="390"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>

    <p class="info-title">园区机构信息&nbsp;&nbsp;{{ zcRecruitmentList.length }}</p>

    <div class="borganization-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="zcRecruitmentList"
          border
          style="width: 650px"
          header-cell-class-name="ly_table_light_header"
          cell-class-name="ly_table_light_cell"
        >
          <el-table-column
            prop="recruitmentId"
            label="园区机构编号"
            align="center"
            width="260"
          ></el-table-column>

          <el-table-column
            prop="recruitmentName"
            label="园区机构全称"
            align="center"
            width="390"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getOrganizationInfo } from "@/api/customCompany.js";
export default {
  data() {
    return {
      zcRecruitmentList: [], // 招聘信息
      zcTeamList: [], // 核心团队信息
      isInit: false
    };
  },
  methods: {
    getInfo() {
      if (this.isInit) {
        return;
      }

      getOrganizationInfo({ id: this.$route.query.id }).then(res => {
        if (res.code == 200) {
          this.isInit = true;

          if (res.data && Array.isArray(res.data.zcRecruitmentList)) {
            this.zcRecruitmentList = res.data.zcRecruitmentList;
          }

          if (res.data && Array.isArray(res.data.zcTeamList)) {
            this.zcTeamList = res.data.zcTeamList;
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.organization-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;

    .table-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 16px;
      color: #333333;

      &::before {
        content: "";
        display: block;
        margin-right: 4px;
        width: 7px;
        height: 7px;
        background-color: #1e9fff;
        border-radius: 50%;
      }
    }
  }
}
::v-deep .el-table--scrollable-x .el-table__body-wrapper{
    overflow: hidden;
}
</style>
